import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { Await } from '@oysterjs/ui/async';
import { PageTitle } from '@oysterjs/ui/page';
import { TextLink } from '@oysterjs/ui/text';

import { LibraryListLoadError } from '~/components/list/library-list-load-error';
import { LibraryListLoading } from '~/components/list/library-list-loading';
import { settingsPage } from '~/components/navigation';
import { AgencyEmailGuidelinesForm } from '~/components/settings/email/agency-email-guidelines-form';
import { EMAIL_TEMPLATES_PATH } from '~/components/email-templates/email-template-paths';

const SettingsEmailPageTitle = ({ children }: React.PropsWithChildren) => (
  <PageTitle
    eyebrow={settingsPage.name}
    title="Email"
    description={
      <>
        How Cara writes emails for your agency. Email templates are in{' '}
        <TextLink href={EMAIL_TEMPLATES_PATH}>Library</TextLink>.
      </>
    }
  >
    {children}
  </PageTitle>
);

type EmailGuidelinesLoaderData = {
  data: Promise<{ emailGuidelines: string[] }>;
};

export const SettingsEmailPage = () => {
  const loaderData = useLoaderData() as EmailGuidelinesLoaderData;

  return (
    <SettingsEmailPageTitle>
      <React.Suspense fallback={<LibraryListLoading title="Loading guidelines…" />}>
        <Await resolve={loaderData.data}>
          {({ emailGuidelines }) => <AgencyEmailGuidelinesForm guidelines={emailGuidelines} />}
        </Await>
      </React.Suspense>
    </SettingsEmailPageTitle>
  );
};

export const SettingsEmailLoadError = () => (
  <SettingsEmailPageTitle>
    <LibraryListLoadError title="We couldn't load your guidelines." />
  </SettingsEmailPageTitle>
);
